<div class="container">
    <div class="row">
        <h2>Ingreso Representante Legal.</h2>
    </div>
    <div class="row mb-3">
        <p class="lead">
            Ingrese rut de empresa a la cual asignar representate legal.
        </p>
    </div>
    <form autocomplete="off" [formGroup]="form" (ngSubmit)="aceptar();" >
        <!-- <div class="row mb-2 g-3 align-items-center">
            
            <div class="col-auto">
                <label for="rut" class="col-form-label">Rut</label>
            </div>
            <div class="col-auto">
                <input formControlName="rut" id="rut" class="form-control">
            </div>
            <div class="col-auto">
                <span  class="form-text">
                    Ingresa rut de Empresa a la cual se asignará el representante legal.
                </span>
            </div>
        </div> -->
        <div class="mb-3">
            <label for="rut" class="form-label">Rut</label>
            <input formControlName="rut" id="rut" class="form-control">
            <div id="rutHelp" class="form-text">Ingresa rut de Empresa a la cual se asignará el representante legal.</div>
        </div>
        <button type="submit" class="btn btn-primary">Aceptar</button>
    </form>
</div>